import { LicenseManager } from "ag-grid-enterprise";
import { getEnvironmentConfig, getRuntimeConfig } from "./runtime.ts";

let isLicenseApplied = false;

type LicenseSource =
  | "build"
  | "runtime"
  | "environment"
  | "meta"
  | "unknown";

type LicenseResolution = {
  key?: string;
  source?: LicenseSource;
};

declare global {
  interface Window {
    __AG_GRID_LICENSE_STATUS__?: {
      applied: boolean;
      source?: LicenseSource;
      timestamp?: string;
    };
  }
}

const resolveLicenseKey = (): LicenseResolution => {
  const buildKey = import.meta.env.VITE_AG_GRID_KEY;

  const runtimeKey = getRuntimeConfig().agGridLicenseKey;
  const environmentKey = getEnvironmentConfig().agGridLicenseKey;
  const metaKey =
    typeof document !== "undefined"
      ? document
          .querySelector('meta[name="ag-grid-license"]')
          ?.getAttribute("content") || undefined
      : undefined;

  if (buildKey) return { key: buildKey, source: "build" };
  if (runtimeKey) return { key: runtimeKey, source: "runtime" };
  if (environmentKey) return { key: environmentKey, source: "environment" };
  if (metaKey) return { key: metaKey, source: "meta" };

  return { key: undefined, source: "unknown" };
};

export const applyAgGridLicense = () => {
  if (isLicenseApplied) return;

  const { key: licenseKey, source } = resolveLicenseKey();

  if (!licenseKey) {
    console.warn(
      "[AG Grid] Enterprise license key missing. Set VITE_AG_GRID_KEY (build) or agGridLicenseKey (runtime) before the app loads to remove the watermark.",
    );
    return;
  }

  LicenseManager.setLicenseKey(licenseKey);

  isLicenseApplied = true;

  if (typeof window !== "undefined") {
    window.__AG_GRID_LICENSE_STATUS__ = {
      applied: true,
      source,
      timestamp: new Date().toISOString(),
    };
  }
};
